/* eslint-disable no-console */
import * as Sentry from '@sentry/nextjs';

// Client-side counterpart to logger.ts. Same API, no ALS (browser doesn't
// support it). User identity is set globally via SentryUserInit on mount.

export function logError(err: unknown, data: object = {}): void {
  console.error(err, data);
  Sentry.withScope(scope => {
    if (Object.keys(data).length > 0) scope.setContext('log_data', { ...data });
    Sentry.captureException(err);
  });
}

export function logMessage(message: string, data: object = {}): void {
  console.log(message, data);
}
